import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { AnalysisLevel } from './types';

interface LevelBreadcrumbProps {
  region: string | null;
  state: string | null;
  district: string | null;
  kv: string | null;
  onNavigate: (level: AnalysisLevel) => void;
}

const LevelBreadcrumb: React.FC<LevelBreadcrumbProps> = function ({ region, state, district, kv, onNavigate }) {
  const crumbs: Array<{ label: string; lvl: AnalysisLevel }> = [
    { label: 'National', lvl: 'RO' },
  ];
  if (region) crumbs.push({ label: region, lvl: 'RO' });
  if (state) crumbs.push({ label: state, lvl: 'STATE' });
  if (district) crumbs.push({ label: district, lvl: 'DISTRICT' });
  if (kv) crumbs.push({ label: kv, lvl: 'KV' });
  if (crumbs.length <= 1) return null;
  return (
    <div className="flex items-center gap-1 flex-wrap text-sm text-gray-500">
      {crumbs.map(function (c, i) {
        return (
          <React.Fragment key={i}>
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-300 flex-shrink-0" />}
            <button
              onClick={function () { onNavigate(c.lvl); }}
              className={
                'hover:text-[#F36B21] transition-colors font-medium truncate max-w-[180px] ' +
                (i === crumbs.length - 1 ? 'text-[#F36B21] pointer-events-none' : '')
              }
              title={c.label}
            >
              {c.label}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LevelBreadcrumb;
